// dimensions of the viewBox/logical size of the entire dashboard
export const width = 1600
export const height = 900

// the minimum distance an item can be moved
// positions & dimensions must be multiples of the resolution
export const horizontalResolution = 10
export const verticalResolution = 10

// minimum allowable width/height for each button
export const minWidth = 10 * horizontalResolution
export const minHeight = 6 * verticalResolution

// when dragging & dropping or resizing,
// this is the multiple of the resolution below which snapping will activate
export const alignmentSnapFactor = 3
// when holding the shift key,
// each tap of an arrow key will move the selected button by this multiple of the resolution
export const fastMoveFactor = 5

export const defaultButtonWidth = 300
export const defaultButtonHeight = 200
